<template>
    <div class="row justify-content-center mt-5">
      <div class="col-md-8">
        <!-- <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">Import profile from LinkedIn <span class="text-danger">(not available for now)</span></div>
          <div class="card-body">
              <b-form
                @submit.prevent="submitLinkedIn">
                  <p class="sub-header">
                      For <strong>quicker sign up,</strong> we recommend to import your profile from
                      LinkedIn using your public profile URL:
                  </p>
                  <p>1. Follow <a href="https://www.linkedin.com/public-profile/settings" target="blank">this link</a></p>
                  <p>2. copy your <strong>public profile URL</strong> (see below)</p>
                  <img class="img-fluid" src="@assets/images/linkedin.png" alt="">
                  <p>3. then paste your public <strong>profile URL</strong> here</p>
                  <input 
                    type="text" 
                    class="form-control"
                    placeholder="Your public profile URL here"
                    v-model="model.url"
                    disabled
                  >
                  <button class="btn btn-primary btn-block mt-2" type="submit" disabled>Retrieve LinkedIn</button>
              </b-form>
          </div>
        </div> -->
        <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">Upload Resume</div>
          <div class="card-body">
            <div class="alert alert-danger" v-if="error">Your file may be missing or incorrect.</div>
            <div class="form-group">
              <label class="form-label" for="my_file_upload_id">Please select your resume</label>
              <input type="file" class="form-control" id="my_file_upload_id">
            </div>

              <Button
                class="btn-block"
                :loading="loading"
                @click='submitCV("my_file_upload_id")'
              >Parse Resume</Button>
          </div>
        </div>
        <div class="text-center">
          <div class="mb-4">OR</div>
          <a
            href="#"
            @click="fillManually"
            class="font-weight-bold"
          >
          Fill Manually
          </a>
        </div>
      </div>
    </div>
    
</template>

<script>
/* import InputTag from 'vue-input-tag' */
import { mapActions } from 'vuex'
import Button from '@components/buttons/button'
import FormMixin from '@mixins/form'


export default {
  mixins:[FormMixin],
  data(){
    return {
      model:{
        url:'',
        id:'',
        manual:false
      },
      error:false
    }
  },
  components:{Button},
  methods:{
    ...mapActions('user', ['findByToken', 'step_2', 'parseCV']),
    submitLinkedIn(){
      /* this.step_2(this.model).then(res => {
        if(res.data.ok){
          //this.$router.push('/user/step_2?key=' + this.$route.query.key)
        }
      }).catch(err => {
        let error = '';
        Object.keys(err.response.data).forEach(key => {
          error += err.response.data[key]
        })
        console.log(error)
      }) */
      alert('Method is disabled!')
    },
    submitCV(fileId){
      var fileInput = document.getElementById(fileId)
      var file = fileInput.files[0];

      this.toggleLoading()

      var formData = new FormData();
      formData.append("file", file);
      formData.append("type", 'candidate');
      formData.append("_id", this.user._id);

      this.parseCV(formData).then(res => {
        this.toggleLoading()
        if(res.data.Resume){
          this.$router.push('/candidate/step_3?type=candidate&id=' + res.data.user.id)
        }else{
          this.error = true
        }
      })

    },
    fillManually(){
      this.model.manual = true
      this.$router.push('/candidate/step_3')
    }
  },
  mounted() {
    this.findByToken({
      token:this.$route.query.key
    }).then(user => {
      this.model.email = user.data.email
      this.model.id = user.data._id
      if(user.data.step == 2){
        this.$router.push('/candidate/step_3?type=candidate&id=' + user.data._id)
      }
    })
  }
}
</script>